import "./index.scss";

const Footer = () => {
  return (
    <footer>
      <img src="/assets/negative-logo-light.svg" alt="Logo" />
      <div className="footer-info">
        {/* <div>© 2024, all rights reserved by ALESSANDROAMARA.DEV</div> */}
        <div>© 2026, tutti i diritti riservati da ALESSANDROAMARA.DEV</div>
        <div>P. Iva n° 17505601009</div>
      </div>
    </footer>
  );
};

export default Footer;
